/*
 * SPDX-FileCopyrightText: 2023 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */

export enum LogoSize {
  SMALL = 32,
  MEDIUM = 64,
  BIG = 256
}
